import React, { Component } from 'react'
import { Input, Icon } from 'antd'

export default class extends Component {
  handleChange = (e) => {
    const { setSearch } = this.props

    if (setSearch) {
      setSearch(e.target.value)
    }
  }

  render () {
    const { filters } = this.props

    return (
      <Input
        value={filters.search}
        prefix={<Icon type='search' style={{ color: 'rgba(0,0,0,.25)' }} />}
        onChange={this.handleChange}
        placeholder='Search'
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Parts/FilterSearch/FilterSearch.jsx